import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { OverlayRef } from '@angular/cdk/overlay';
import { MatMenuTrigger } from '@angular/material/menu';
import * as lodash from 'lodash';
import { map } from 'rxjs/operators';

import { OrganizationStatus } from 'app/types/organization';
import { SubscriptionBase } from 'app/base';
import { AccountService, LoginService, OrganizationService } from 'app/shared';
import { ProfileService } from '../profile.service';
import { LayoutService } from '../layout.service';



const ORG_PATH_PATTERN = /([/\w]+)(\/organization\/\d+\/)([/\w]*)/;

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['navbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    'class': 'flex-shrink-0'
  }
})
export class NavbarComponent extends SubscriptionBase implements OnInit {
  account: App.Account;
  currOrg: App.Organization;
  currProject: App.Project;

  @ViewChild('orgMenuTrigger') orgMenuTrigger: MatMenuTrigger;

  constructor(
    private changeDetector: ChangeDetectorRef,
    public router: Router,
    private loginService: LoginService,
    public layoutService: LayoutService,
    public accountService: AccountService,
    public profileService: ProfileService,
    public organizationService: OrganizationService
  ) {
    super();
  }

  ngOnInit(): void {
    this.subscription.add(
      this.accountService.account$
        .pipe(
          map((account): App.Account => {
            if (account) {
              this.account = account;
              this.changeDetector.markForCheck();
            }
            return account;
          })
        )
        .subscribe()
    );
    this.subscription.add(
      this.accountService.getSelectedOrganization()
        .subscribe((data): void => {
          if (data && !data.alias) {
            data.alias = `${data.organizationId}-${data.name}`;
          }
          this.currOrg = data;
          this.changeDetector.markForCheck();
        })
    );
    this.subscription.add(
      this.accountService.getSelectedProject()
        .subscribe((data): void => {
          this.currProject = data;
          this.changeDetector.markForCheck();
        })
    );
  }

  trackById(index: number, item: App.Organization): number {
    return item.id;
  }

  isTerminatedOrg(value: App.Organization): boolean {
    return lodash.toLower(value.status) === lodash.toLower(OrganizationStatus.Terminated);
  }

  onOrgMenuTrigered(): void {
    if (this.orgMenuTrigger.menuOpen) {
      const overlayRef = this.orgMenuTrigger['_overlayRef'] as OverlayRef;

      setTimeout((): void => {
        const selectedItem = overlayRef.overlayElement.querySelector('.mat-menu-item.active');

        if (selectedItem) {
          selectedItem.scrollIntoView();
        }
      });
    }
  }

  setSelectedOrganization(value: App.Organization): void {
    this.accountService.setSelectedOrganization(value);
  }

  logout() {
    this.loginService.logout()
      .subscribe((): void => {
        this.router.navigate(['/auth', 'sign-in']);
      });
  }
}
